import * as _4 from 'lodash4';
import { Datasource, IDatasource, Metasource } from 'utility-ng-kernel';
import { APTerm, IAPTermMeta } from '../builders/ap_term_builder';
import { APTermServant } from '../servants/ap_term_servant';

export interface IAPTermsDatasource extends IDatasource<APTerm, {}, IAPTermMeta> {}

angular.module('capability-ng-academic-planner').factory('ngAPTermsDatasource', () => {
  return new Datasource<APTerm, {}, IAPTermMeta>({
    builderType: APTerm,
    updateMode: 'merge'
  }).includeMetasource<IAPTermMeta>((datasource) => {
    return new Metasource<APTerm, IAPTermMeta>(datasource)
      .includeAttribute('_isTermCompleted', (term) => !APTermServant.isCompleted(term))
      .includeAttribute('_disablePickTimes', (term) => APTermServant.isRegistrationButtonDisabled(term));
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/datasources/ap_terms_datasource.ts